"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CoachUser {
    constructor(client) {
        this.getPersonalInformation = (_token) => {
            return new Promise(async (resolve, reject) => {
                try {
                    const { data: { user }, } = await this.client.post("/graphql", {
                        operationName: "user",
                        query: `query user {
                    user {
                        id
                        firstName
                        lastName
                        email
                        birthDate
                        phoneNumber
                        roles
                    }
                }`,
                    });
                    resolve({
                        id: user.id.toString(),
                        name: user.firstName + " " + user.lastName,
                        email: user.email,
                        birthDate: user.birthDate,
                        telephoneNumber: user.phoneNumber,
                        roles: user.roles,
                    });
                }
                catch (e) {
                    reject(e);
                }
            });
        };
        this.client = client;
    }
}
exports.default = CoachUser;
//# sourceMappingURL=CoachUser.js.map